import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filter: {
        startDate: null,
        endDate: null,
        sr_managers: []
    },
    rows: [],
    fetched: false,
};

const reAssignedLeadReportSlice = createSlice({
    name: "reAssignleadReport",
    initialState,

    reducers: {
        saveReAssignedLeadReport(state, action) {
            state.filter = action.payload.filter;
            state.rows = action.payload.rows;
            state.fetched = action.payload.fetched;
        },

        clearReAssignedLeadReport(state) {
            state.filter = initialState.filter;
            state.rows = [];
            state.fetched = false;
        },
    },
});

export const { saveReAssignedLeadReport, clearReAssignedLeadReport } = reAssignedLeadReportSlice.actions;

export default reAssignedLeadReportSlice.reducer;
